import React from "react";
import { Link } from "react-router-dom";
import "../styles/components/footer.css";

function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container footer__grid">
                <div>
                    <h3>Dahlia Health Care Services</h3>
                    <p>
                        Delivering trusted care, staffing, training, and specialist support
                        with professionalism and compassion.
                    </p>
                </div>

                <div>
                    <h4>Quick Links</h4>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about">About</Link></li>
                        <li><Link to="/services">Services</Link></li>
                        <li><Link to="/contact">Contact</Link></li>
                    </ul>
                </div>

                <div>
                    <h4>Services</h4>
                    <ul>
                        <li>Staff Recruitment</li>
                        <li>Mental Health Training</li>
                        <li>Domiciliary Care</li>
                        <li>Children’s Services</li>
                        <li>Secure Transport</li>
                    </ul>
                </div>

                <div>
                    <h4>Contact</h4>
                    <ul>
                        <li>info@dahlia-healthcareservices.co.uk</li>
                        <li>+44 0000 000000</li>
                        <li>United Kingdom</li>
                    </ul>
                </div>
            </div>

            {/* Copyright */}
            <div className="footer__bottom">
                <div className="container footer__bottom-inner">
                    <p>© {year} Dahlia Health Care Services. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;